import React from 'react'
import { Button, Collapse, Form, Input, message, Switch } from 'antd'
import { ShelterKioskReasonContextData } from '../../../../context/ShelterKioskReasonContext'
import { FormComponent } from '../../../BaseComponent'
import { ShelterKioskReasonUpdateRequest } from '../../../../services/api/interfaces/ApiRequest'

type EditShelterReasonProps = {
  branchUuid: string,
  reasonUuid: string,

  context: ShelterKioskReasonContextData
}

export default class EditShelterReason extends FormComponent<EditShelterReasonProps> {

  private getReason = () => {
    const { branchUuid, reasonUuid, context } = this.props

    return context.shelterKioskReasons?.find(v => v.branch?.uuid === branchUuid && v.reason?.uuid === reasonUuid)
  }

  private handleSave = async (values: any) => {
    const { context } = this.props
    
    try {
      const shelterReason = this.getReason()

      if (shelterReason) {
        const payload: ShelterKioskReasonUpdateRequest = {
          shelter_kiosk_reason: {
            ...values,
            uuid: shelterReason.uuid
          }
        }

        await context.requestShelterKioskReasonUpdate(payload)
        message.success('Shelter kiosk reason saved successfully!')
      }
    } catch (err) {
      message.error(`Could not save shelter kiosk reason options. Reason: ${err}`)
    }
  }

  render() {
    const { context } = this.props

    const values = this.getReason() || {}

    return (
      <Collapse>
        <Collapse.Panel key="options" header="Kiosk Reason Option">
          <Form
            name="shelter_kiosk_reason"
            initialValues={values}
            onFinish={this.handleSave}
          >
            <Form.Item
              label="Reason name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Choose a name for your reason'
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="End message (displayed when user finishes checking in)"
              name="end_message"
              rules={[
                {
                  required: true,
                  message: 'Choose an end message for the reason'
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Add Visitor with WAITLIST status"
              name="wait_list_on_end"
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item
              label="Custom reason response"
              name="custom_reason_response"
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Form.Item style={{ marginTop: 32 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={context.fetching || false}
                ref={(refs) => this.actionRefs.save = refs}
                block
              >
                Save
              </Button>
            </Form.Item>
          </Form>
        </Collapse.Panel>
      </Collapse>
    )
  }
}
